import styled from 'styled-components/native';
import { SectionHeading as SectionHeadingBase } from '~/components/sectionHeading';

export const SectionHeading = styled(SectionHeadingBase)`
    padding: 16px 16px 8px 16px;
`;
